/**
 * Wholesome Story — consent-gated tracking loader.
 *
 * Works WITH Shopify's native Customer Privacy / cookie banner
 * (Settings > Customer privacy). Theme-level analytics/marketing scripts are
 * shipped as <script type="text/plain" data-consent-category="..."> so the
 * browser does NOT run them on page load. This loader injects each script only
 * once Shopify reports the matching consent as allowed, and re-checks whenever
 * the visitor updates their choice via the banner.
 *
 * Region behaviour is handled by Shopify for free:
 *   - US (opt-out):  consent defaults to allowed  -> scripts load immediately.
 *   - EU/UK (opt-in): consent defaults to denied   -> scripts wait for Accept.
 *
 * Categories in use:
 *   analytics  -> Microsoft Clarity (project wxunkceddu)
 *   marketing  -> Klaviyo onsite
 *
 * NOTE: this only gates scripts hard-coded in the theme. Pixels injected by
 * Shopify apps / Web Pixels (Meta, GA4, TikTok, Shopify Analytics, the Reamaze
 * app) are gated automatically by Shopify's native consent — nothing to do here.
 */
(function () {
  'use strict';

  // Fail-open guard: if the Customer Privacy API never initialises (e.g. the
  // native banner has not been enabled yet in admin), load the scripts after
  // this delay so analytics/marketing are not silently lost. Once the banner
  // is enabled the API resolves well before this fires.
  var FALLBACK_MS = 4000;
  var resolved = false;

  function injectCategory(category) {
    var nodes = document.querySelectorAll(
      'script[type="text/plain"][data-consent-category="' + category + '"]'
    );
    nodes.forEach(function (node) {
      var s = document.createElement('script');
      for (var i = 0; i < node.attributes.length; i++) {
        var attr = node.attributes[i];
        // Drop the gating attributes; everything else (src, async, id…) carries over.
        if (attr.name === 'type' || attr.name === 'data-consent-category') continue;
        s.setAttribute(attr.name, attr.value);
      }
      if (!node.src) {
        s.textContent = node.textContent;
      }
      node.parentNode.insertBefore(s, node.nextSibling);
      node.parentNode.removeChild(node);
    });
  }

  // cp = window.Shopify.customerPrivacy (or null to fail open).
  // injectCategory is idempotent — once a node is injected it is removed, so
  // re-running on consent change only picks up newly-allowed categories.
  function applyConsent(cp) {
    var analyticsOk = true;
    var marketingOk = true;
    if (cp) {
      try { analyticsOk = cp.analyticsProcessingAllowed(); } catch (e) { analyticsOk = false; }
      try { marketingOk = cp.marketingAllowed(); } catch (e) { marketingOk = false; }
    }
    if (analyticsOk) injectCategory('analytics');
    if (marketingOk) injectCategory('marketing');
  }

  function failOpen() {
    if (resolved) return;
    resolved = true;
    applyConsent(null);
  }

  function start() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      resolved = true;
      applyConsent(window.Shopify.customerPrivacy);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error || !window.Shopify.customerPrivacy) {
            failOpen();
            return;
          }
          resolved = true;
          applyConsent(window.Shopify.customerPrivacy);
        }
      );
      return;
    }
    // No Shopify privacy surface at all — fail open.
    failOpen();
  }

  // Re-apply whenever the visitor accepts/updates consent via the native banner.
  document.addEventListener('visitorConsentCollected', function () {
    resolved = true;
    applyConsent(window.Shopify && window.Shopify.customerPrivacy);
  });

  // "Your Privacy Choices" footer link reopens the Shopify consent preferences modal.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-privacy-preferences]') : null;
    if (!trigger) return;
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  setTimeout(failOpen, FALLBACK_MS);

  start();
})();
